import { render } from "./UserDocuments.vue?vue&type=template&id=5d38e51a&scoped=true&ts=true"
import script from "./UserDocuments.vue?vue&type=script&lang=ts"
export * from "./UserDocuments.vue?vue&type=script&lang=ts"

import "./UserDocuments.vue?vue&type=style&index=0&id=5d38e51a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d38e51a"]])

export default __exports__